import React from "react";

interface StepHeadingProps {
    title: string;
    description: string;
}

export const StepHeading: React.FC<StepHeadingProps> = props => (
    <div>
        <h3 className="font-medium text-gray-900">{props.title}</h3>
        <p className="text-sm text-gray-500">{props.description}</p>
    </div>
);

interface FieldProblemProps {
    problem: string | null;
}

export const FieldProblem: React.FC<FieldProblemProps> = props =>
    props.problem ? <p className="mt-1 text-sm text-red-600">{props.problem}</p> : null;

interface FieldWarningProps {
    warning: string | null;
}

export const FieldWarning: React.FC<FieldWarningProps> = props =>
    props.warning ? <p className="mt-1 text-sm text-amber-700">{props.warning}</p> : null;

interface FieldHintProps {
    children: React.ReactNode;
}

export const FieldHint: React.FC<FieldHintProps> = props => (
    <p className="mt-1 text-xs text-gray-500">{props.children}</p>
);

export const optionOrNull = <T extends string>(
    options: readonly T[],
    value: string,
): T | null => options.find(option => option === value) ?? null;
